var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Pdf",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-pdf","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <rect width="115.3" height="7" x="67.8" y="147.9"/>
  <rect width="115.3" height="7" x="67.8" y="175.4"/>
  <rect width="115.3" height="7" x="67.8" y="202.8"/>
  <path d="M181.5 38h-113v85.9h113V38zm-7 78.9h-99V45h99v71.9z"/>
  <path d="M27.4.7v248.1H224V.7H27.4zM215 239.8H36.4V9.7H215v230.1z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/pdf.svg